import { render, staticRenderFns } from "./titlePreview.vue?vue&type=template&id=0fbe22ba&scoped=true"
import script from "./titlePreview.vue?vue&type=script&lang=js"
export * from "./titlePreview.vue?vue&type=script&lang=js"
import style0 from "./titlePreview.vue?vue&type=style&index=0&id=0fbe22ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe22ba",
  null
  
)

export default component.exports